import React, { useState } from 'react';
import { TextField, Button, Typography, Box } from '@mui/material';

const PhoneNumberForm = ({onChange}) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [error, setError] = useState('');

  const handleChange = (event) => {
    const value = event.target.value;

    // Allow only digits and ensure the length is 10
    if (/^\d{0,10}$/.test(value)) {
      setPhoneNumber(value);
      onChange(value);
      setError(''); // Clear error message if valid
    } else {
      setError('Please enter a valid 10-digit phone number.');
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (phoneNumber.length === 10) {
      alert(`Phone Number submitted: ${phoneNumber}`);
      // You can proceed with form submission logic here
    } else {
      setError('Please enter a valid 10-digit phone number.');
    }
  };

  return (
      <TextField fullWidth
        label="Phone Number"
        variant="outlined"
        value={phoneNumber}
        onChange={handleChange}
        error={!!error}
        helperText={error}
      />
  );
};

export default PhoneNumberForm;
